var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResume1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 683,
    height: 646,
    viewBox: "0 0 683 646",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M667 168.499H508.239C508.239 75.9091 433.587 0.850098 341.5 0.850098C249.413 0.850098 174.761 75.9091 174.761 168.499H16C11.7565 168.499 7.68687 170.185 4.68629 173.185C1.68571 176.186 0 180.256 0 184.499L0 629.999C0 634.243 1.68571 638.312 4.68629 641.313C7.68687 644.313 11.7565 645.999 16 645.999H667C671.243 645.999 675.313 644.313 678.314 641.313C681.314 638.312 683 634.243 683 629.999V184.499C683 180.256 681.314 176.186 678.314 173.185C675.313 170.185 671.243 168.499 667 168.499Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResume1);
export default __webpack_public_path__ + "static/media/resume1.932b7159694fec7d01f90a1cea08aa8a.svg";
export { ForwardRef as ReactComponent };